import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';

import LoginForm from '../../forms/Login';
import PageHeader from '../../modules/PageHeader';
import PageMeta from '../../modules/PageMeta';
import PageSection from '../../modules/PageSection';
import SidebarColumn from '../../modules/SidebarColumn';
import ContentColumn from '../../modules/ContentColumn';
import PageSidebar from '../../modules/PageSidebar';
import Page from '../../pages/Page';
import ReferrerLink from '../../modules/ServiceReferrerLink';
import AlertBox from '../../modules/AlertBox';

import * as sessionActions from '../../../actions/session';
import * as serviceActions from "../../../actions/services";
import qs from "query-string";
import AlertMessage from "../../modules/AlertMessage/index";

class Login extends React.Component {

    constructor() {
        super();

        this.state = {
            redirectToReferrer: false
        };

        this._login = this._login.bind(this);
    }

    componentDidMount() {
        const serviceId = this._getSearchParams().service;

        this.props.refreshServiceReferrer(serviceId);
    }

    _login(params) {

        return this.props.login(params)
            .then(() => this.setState({ redirectToReferrer: true }));
    }

    _getSearchParams() {
        return qs.parse(this.props.location.search);
    }

    render() {

        const queryParams = this._getSearchParams();

        const { from } = this.props.location.state || { from: { pathname: '/services' } };

        if (this.state.redirectToReferrer) {
            return (
                <Redirect to={from} />
            )
        }

        const { serviceReferrer } = this.props;

        return (
            <Page>
                <PageMeta title="Login" />

                <SidebarColumn>
                    <PageSidebar />
                </SidebarColumn>

                <ContentColumn>
                    <PageHeader>
                        <h1>Login</h1>

                        <span>Welcome to the RHE Global Single Sign On service.</span>
                    </PageHeader>

                    {!!queryParams.service && serviceReferrer &&
                        <PageSection>
                            <ReferrerLink service={serviceReferrer}/>
                        </PageSection>
                    }

                    <AlertMessage>
                        {queryParams.password_reset === 'true' && (
                            <PageSection>
                                <AlertBox theme="success">
                                    Your password has been reset. You may now sign into RHE Global services with your new password.
                                </AlertBox>
                            </PageSection>
                        )}
                    </AlertMessage>

                    <PageSection>

                        <LoginForm onSubmit={this._login} />

                    </PageSection>

                </ContentColumn>
            </Page>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        serviceReferrer: state.services.serviceReferrer
    }
};

const mapDispatchToProps = dispatch => {
    return {
        refreshServiceReferrer(serviceId) {
            dispatch(serviceActions.refreshServiceReferrer(serviceId));
        },
        login(params) {
            return dispatch(sessionActions.login(params));
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);